export default "<div *ngIf=\"isVisible && message\" class=\"form-text text-danger\">\n    <i class=\"fa fa-exclamation-triangle\"></i> {{ message}}\n</div>\n";